// js/common/cart/vzk-free-gift-bar.js
class VanzakFreeGiftBart extends HTMLElement{
    async connectedCallback() {
        document.addEventListener("cart:change", this._onCartChangedListener.bind(this));
    }
    _onCartChangedListener(e) {
        const cartTotal = e.detail.cart.total_price / 100.0;
        const progress = Math.min(1, Math.max(0, cartTotal / this.dataset.threshold)); 
        

        cartTotal > this.dataset.threshold
            ? this.reachedGoal()
            : this.unreachedGoal(cartTotal);
            
        this.setProgressBar(progress);
    }

    reachedGoal() {
        const msg = this.dataset.reachedMessage;
        this.setMessage(msg);
    }

    unreachedGoal(cartTotal, progress) {
        const remaining = (Number(this.dataset.threshold) - cartTotal).toFixed(2);
        const currency = this.dataset.currencyCode || 'BRL';

        const remainingText = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency
        }).format(remaining);

        const msg = this.dataset.unreachedMessage.replace('[remaining]', remainingText);
        
        this.setMessage(msg);
    }

    async setMessage(msg) {
        const el = this.querySelector('.progess-bar__message');
        if (el) el.innerHTML = msg;
    }

    setProgressBar(progress) {
        const progressBar = this.querySelector('.progress-bar');
        if (!progressBar) return;
        progressBar.style.setProperty('--progress', progress);
    }
}

if (!window.customElements.get('vzk-free-gift-bar')) {
    window.customElements.define('vzk-free-gift-bar', VanzakFreeGiftBart);
}